import React from 'react';
import styles from './App.module.scss'
import { Header } from '../Header/Header';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Footer } from '../Footer/Footer';
import { Price } from '../Price/Price';
import { Route, Routes } from 'react-router-dom';
import { Training } from '../Training/Training';
import { Helmet } from 'react-helmet-async';
import { ModalUp } from '../common/ModalUp/ModalUp';
import { Online } from '../Online/Online';
import { Sliders } from '../Sliders/Sliders';
import { Info } from '../Info/Info';
import { Contacts } from '../common/Contacts/Contacts';
import { ContactsMobile } from '../common/ContactsMobile/ContactsMobile';

const theme = createTheme({
    palette: {
        primary: {
            main: '#053543',
        },
    },
});

export const App = () => {
    // console.log("App")

    return <ThemeProvider theme={theme}>
        <Helmet>
            <title>Педикюр Онлайн курсы Обучение Плёнки Слайдеры - </title>
            <meta
                name="description"
                content="Педикюр онлайн курс, обучение, педикюр, педикюр лето, лучший педикюр, идеи педикюра, обучение педикюр, онлайн обучение педикюр, педикюр 2022, pedicure, pedicure courses" />
            <link rel="canonical" href="/" />
        </Helmet>

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }}>
            <Header />
            <div style={{
                backgroundColor: '#ffd700', // Bright Gold/Yellow
                color: '#000',
                textAlign: 'center',
                padding: '12px 15px',
                fontSize: '17px',
                width: '100%',
                borderBottom: '2px solid #daa520',
                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}>
                📢 Наш сайт переехал! Новые курсы здесь: {' '}
                <a href="https://academy.arsnails.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#053543', textDecoration: 'underline', borderBottom: '2px solid #053543', paddingBottom: '2px' }}>
                    academy.arsnails.ru
                </a>
            </div>
        </div>
        <div className={styles.appContainer} style={{ marginTop: '130px' }}>
            <Routes>
                <Route path="/" element={<Online />} />
                <Route path="/training" element={<Training />} />
                {/*<Route path="/price" element={<Price/>}/>*/}
                <Route path="/sliders" element={<Sliders />} />
                <Route path="/info" element={<Info />} />
                {/*<Route path="/info" element={<Info/>}/>*/}
                {/*<Route path="/goods" element={<GoodsForSale/>}/>*/}
            </Routes>
        </div>
        <Footer />
        <ModalUp speed={20} />
    </ThemeProvider>
}
